var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconLock = function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#D9C4BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M14.167 8.333H5.833c-.92 0-1.666.747-1.666 1.667v5.833c0 .92.746 1.667 1.666 1.667h8.334c.92 0 1.666-.746 1.666-1.667V10c0-.92-.746-1.667-1.666-1.667"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M6.667 8.333v-2.5a3.333 3.333 0 0 1 6.666 0v2.5M10 11.667v2.5"
  }))));
};
export default SvgIconLock;